// extracted by mini-css-extract-plugin
export default {"textContainer":"BYG5MY","rtlContainer":"CVHgH8","iconContainer":"_I98Vx"};